<div
  class="pill"
  [ngClass]="
    isSelected ? 'selected-background-color' : 'default-background-color'
  "
>
  {{ text }}
</div>
